module.exports = __webpack_public_path__ + "img/8_70.8a8c6174.png";